<!-- src/components/EventPage.vue -->
<template>
  <div class="group-share-page">
    <div class="mask" v-if="maskShow">
     <div class="imgArea">
      <img :src="leadImg"/>  
     </div>
      <a class="btn" @click="maskShow = false">关闭</a>
    </div>
    <header class="header">
      <div class="left-area">
        <i></i>Ta 想与你搭个圈
      </div>
      <button class="login-button" @click="openLoadPage">立即打开</button>
    </header>
    <div class="top-content">
      <img :src="detialMsg.groupPic" />
      <div class="countdown">
        <span
          v-if="detialMsg.groupPurchaseStatus == 0 || detialMsg.groupPurchaseStatus == 1"
        >倒计时：{{ days }}天{{ hours }}小时{{ minutes }}分{{ seconds }}秒</span>
        <span v-if="detialMsg.groupPurchaseStatus == 2 ">已成团</span>
        <span v-if="detialMsg.groupPurchaseStatus == 3 ">已完成</span>
        <span v-if="detialMsg.groupPurchaseStatus == 4 ">已结束</span>
        <span v-if="detialMsg.groupPurchaseStatus == 5 ">已结束</span>
      </div>
      <div class="countdown-icon"></div>
      <div class="xin-icon"></div>
    </div>
    <div class="event-details">
      <h2 class="title-area">{{detialMsg.title}}</h2>
      <p>
        <i class="i1"></i>
        时间：{{detialMsg.storeOpenHours}}
      </p>
      <p>
        <i class="i2"></i>
        地点：{{detialMsg.storeAddress}}
      </p>
    </div>
    <div class="btm-content">
      <h3 class="title-area">参团成员</h3>
      <div
        class="group-members"
        v-if="detialMsg.restrictGroupType == 0 || detialMsg.restrictGroupType == 1"
      >
        <div class="member-list">
          <div class="header-area">
            <span class="count"></span>
            <a
              @click="openLoadPage"
              class="remaining-count"
              v-if="detialMsg.restrictGroupType == 1"
            >仅剩{{ detialMsg.peopleNum + 1 - detialMsg.joyUserInfos.length }}个名额></a>
          </div>
          <div class="members clr">
            <div
              v-for="(member,key) in detialMsg.joyUserInfos"
              :key="key"
              class="member fl"
              @click="openLoadPage"
            >
              <img :src="member.avatar" :alt="member.nickname" class="avatar" />
              <div class="name">{{ member.nickname }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="group-members" v-if="detialMsg.restrictGroupType == 2">
        <div class="member-list">
          <div class="header-area">
            <img :src="sex1" alt="emoji" class="emoji" />
            <span class="title">男生</span>
            <span class="count">{{ detialMsg.boyNum }}人</span>
            <a
              @click="openLoadPage"
              class="remaining-count"
            >仅剩{{ detialMsg.boyNum - boyList.length + boyNum }}个名额></a>
          </div>
          <div class="members clr">
            <div v-for="(member,key) in boyList" :key="key" class="member fl" @click="openLoadPage">
              <img :src="member.avatar" :alt="member.nickname" class="avatar" />
              <div class="name">{{ member.nickname }}</div>
            </div>
          </div>
        </div>
        <div class="member-list">
          <div class="line"></div>
          <div class="header-area">
            <img :src="sex2" alt="emoji" class="emoji" />
            <span class="title">女生</span>
            <span class="count">{{ detialMsg.girlNum }}人</span>
            <a
              @click="openLoadPage"
              class="remaining-count"
            >仅剩{{detialMsg.girlNum - girlList.length + girlNum }}个名额></a>
          </div>
          <div class="members clr">
            <div
              v-for="member in girlList"
              :key="member.id"
              class="member fl"
              @click="openLoadPage"
            >
              <img :src="logo" :alt="member.nickname" class="avatar" />
              <div class="name">{{ member.nickname }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="event-info">
        <h3 class="title-area">详情信息</h3>
        <div class="detial-content">
          <p class="tit">套餐详情</p>
          <ul>
            <li
              v-for="(item,key) in detialMsg.setMealDetail"
              :key="key"
            >{{item.product}} * {{item.productNum}}</li>
          </ul>
          <!-- <p class="tit">环境图片</p>
          <div class="environment-images">
            <img :src="logo" alt="环境图片1" />
            <img :src="logo" alt="环境图片2" />
          </div>-->
        </div>
      </div>
      <div class="event-notice">
        <h3 class="title-area">活动须知</h3>
        <div class="activityInstruction">
          <p class="tit">报名须知</p>
          <ul>
            <li>活动平台可随时止报名</li>
            <li>请保持手机畅通以便接收活动通知</li>
          </ul>
          <p class="tit">退款政策</p>
          <ul>
            <li>活动开始前24小时免费退还</li>
          </ul>
          <p class="tit">温馨提示</p>
          <ul>
            <li>{{detialMsg.tips}}</li>
            <!-- <li>在活动过程中如遇到可疑违法活动，请及时向「搭个圈」官方客服举报。因向陌生人透漏个人信息造成的信息安全问题及财产损失 ，「搭个圈」不承担赔偿责任</li> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="apply-buttom">
      <div class="btn" @click="openLoadPage">立即报名</div>
    </div>
  </div>
</template>

<script>
import MobileDetect from 'mobile-detect';
import { getGroupPurchaseInfo } from '@/api/groupShare.js';

export default {
  data() {
    return {
      leadImg: require("../../assets/images/ground.png"),
      groupPurchaseId: '',
      logo: require("../../assets/images/logo.png"),
      sex1: require("../../assets/images/sex1.png"),
      sex2: require("../../assets/images/sex2.png"),
      members: [
        { id: 1, name: '辛华', avatar: '../../assets/images/logo.png' },
        { id: 2, name: '冯文盛', avatar: '../../assets/images/logo.png' },
        { id: 3, name: '柯高峰', avatar: '../../assets/images/logo.png' },
        { id: 4, name: '毛周', avatar: '../../assets/images/logo.png' },
        { id: 5, name: '许志畅', avatar: '../../assets/images/logo.png' },
        { id: 6, name: '许志畅3', avatar: '../../assets/images/logo.png' },
        { id: 7, name: '许志畅4', avatar: '../../assets/images/logo.png' },
      ],
      members2: [
        { id: 1, name: '辛华', avatar: '../../assets/images/logo.png' },
        { id: 2, name: '冯文盛', avatar: '../../assets/images/logo.png' },
        { id: 3, name: '柯高峰', avatar: '../../assets/images/logo.png' }
      ],
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      detialMsg: {
        groupPic: require("../../assets/images/topBg.png"),
        title: '',
        storeOpenHours: '',
        storeAddress: '',
        groupPurchaseStatus: '0',
        joyUserInfos: [],
        setMealDetail: [],
        girlNum: 0,
        boyNum: 0,
        tips: ''
      },
      remaining: 5,
      remaining2: 10,
      price: '99.99',
      md: new MobileDetect(window.navigator.userAgent),
      boyList: [],
      girlList: [],
      boyNum: 0,
      girlNum: 0,
      maskShow: false
    };
  },
  created() {
    if (this.$route.query.groupPurchaseId) {
      this.groupPurchaseId = this.$route.query.groupPurchaseId
      this.getGroupPurchaseInfo()
    }
  },
  mounted() {
  },
  methods: {
    getGroupPurchaseInfo() {
      getGroupPurchaseInfo({
        "groupPurchaseId": this.groupPurchaseId
      }).then(res => {
        if (res.code == '0000') {
          this.boyList = []
          this.girList = []
          this.detialMsg = JSON.parse(JSON.stringify(res.data))
          if (this.detialMsg.restrictGroupType == 2) {
            this.detialMsg.joyUserInfos.forEach(item => {
              if (item.isColonel) {
                if (item.sex == 1) {
                  this.boyNum = 1
                }
                if (item.sex == 2) {
                  this.girlNum = 1
                }
              }
              if (item.sex == 1) {
                this.boyList.push(item)
              }
              if (item.sex == 2) {
                this.girlList.push(item)
              }
            })
          }
          if (this.detialMsg.groupPurchaseStatus == 0 || this.detialMsg.groupPurchaseStatus == 1) {
            this.startTimer(this.detialMsg.endTime)
          }
        }
      })
    },
    openLoadPage() {
      if (this.md.is('WeChat')) {
        this.maskShow = true
        //  this.$Message.warning('请在默认浏览器中打开！')
        return
      }
      console.log(this.md.os())
      if (this.md.os() === 'iOS') {
        window.location.href = 'circledetail://circle?id=' + this.groupPurchaseId; // 替换成你的iOS App的Scheme
        setTimeout(() => {
          this.$router.push('/loadPage')
        }, 1500);
      } else if (this.md.os() === 'AndroidOS') {
        window.location.href = 'circledetail://circle?id=' + this.groupPurchaseId; // 替换成你的Android App的Scheme
        setTimeout(() => {
          this.$router.push('/loadPage')
        }, 1500);
      }
      //   this.$router.push('/loadPage')
    },
    startTimer(date) {
      // 设置倒计时结束时间（6小时12分26秒后）
      const endTime = new Date(date)
      // 每秒更新倒计时时间
      this.timer = setInterval(() => {
        const remainingTime = endTime - Date.now();
        if (remainingTime > 0) {
          this.days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
          this.hours = Math.floor(remainingTime / (1000 * 60 * 60));
          this.minutes = Math.floor((remainingTime % (1000 * 60 * 60)) / (1000 * 60));
          this.seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);
        } else {
          // 倒计时结束
          clearInterval(this.timer);
          this.hours = 0;
          this.minutes = 0;
          this.seconds = 0;
        }
      }, 1000);
    },
  }
};
</script>

<style scoped lang='scss'>
.group-share-page {
  padding-top: 40px;
  //   padding-bottom: 80px;
  background: #f0eefa;
  .mask{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding-top: 20px;
    padding-right: 20px;
    background: rgba(0,0,0,.8);
    z-index: 20;
    .imgArea{
      width: 100%;
      text-align: right;
    }
    img{
      width: 80%;
    }
    .btn{
      display: block;
      margin: 60px auto 0;
      width: 80px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      color: #fff;
      border: 1px solid #fff;
      border-radius: 16px;
    }
  }
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 4px 16px;
  background: #fff;
  align-items: center;
  z-index: 10;
  .left-area {
    display: flex;
    align-items: center;
    color: #9055fc;
    i {
      display: inline-block;
      margin-right: 5px;
      width: 32px;
      height: 32px;
      background: url(../../assets/images/logo.png) no-repeat;
    }
  }
  .login-button {
    border: none;
    cursor: pointer;
    width: 72px;
    height: 24px;
    line-height: 24px;
    background: #9055fc;
    border-radius: 12px;
    color: #fff;
  }
}
.top-content {
  position: relative;
  height: 350px;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  //   background: url(../../assets/images/topBg.png) no-repeat;
  //   background-size: 100% 100%;
  .countdown {
    position: absolute;
    width: 100%;
    padding-left: 20px;
    background: linear-gradient(104deg, #8c86ff 0%, #d0a5fe 100%);
    box-shadow: 0px 2px 3px 0px rgba(152, 131, 254, 0.3578),
      inset 1px 1px 0px 0px rgba(119, 96, 235, 0.5119),
      inset -1px -1px 0px 0px rgba(255, 255, 255, 0.484);
    border-radius: 20px 20px 0px 0px;
    height: 60px;
    line-height: 40px;
    bottom: 0;
    color: #fff;
    font-size: 14px;
  }
  .countdown-icon {
    position: absolute;
    bottom: -10px;
    right: 40px;
    height: 100px;
    width: 70px;
    background: url(../../assets/images/djsIcon.png) no-repeat;
    z-index: 2;
  }
  .xin-icon {
    position: absolute;
    bottom: 18px;
    right: 120px;
    height: 38px;
    width: 38px;
    background: url(../../assets/images/xin.png) no-repeat;
    z-index: 2;
  }
}
.event-details {
  position: relative;
  padding: 25px 20px;
  margin-top: -20px;
  margin-bottom: 5px;
  background: #fff;
  border-radius: 20px 20px 0 0;
  .title-area {
    font-size: 20px;
    margin-bottom: 15px;
  }
  p {
    display: flex;
    align-items: center;
    line-height: 30px;
    font-size: 12px;
    color: #222222;
    i {
      display: inline-block;
      margin-right: 8px;
      width: 12px;
      height: 12px;
      background: #000;
    }
    .i1 {
      background: url(../../assets/images/time.png) no-repeat;
    }
    .i2 {
      background: url(../../assets/images/dz.png) no-repeat;
    }
  }
}
.btm-content {
  padding: 16px 20px;
  background: #faf9ff;
  .title-area {
    font-size: 16px;
    color: #222222;
    margin: 0 0 15px;
  }
  .group-members {
    padding: 16px;
    background: linear-gradient(180deg, #f3eefd 0%, #ffffff 100%), #faf9ff;
    border-radius: 20px 20px 0px 0px;
  }

  .member-list {
    .line {
      margin: 20px 0;
      height: 1px;
      background: #f0eefa;
    }
    .header-area {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
    }
    .emoji {
      width: 24px;
      height: 24px;
      margin-right: 0.5rem;
    }
    .title {
      font-size: 1.2rem;
      font-weight: bold;
      margin-right: 0.5rem;
    }
    .count {
      font-size: 1rem;
      color: #666;
      margin-right: auto;
    }
    .remaining-count {
      font-size: 1rem;
      color: #9460e8;
      text-decoration: none;
    }
    .members {
      //   display: flex;
      //   justify-content: space-around;
      //   overflow-x: auto;
      //   white-space: nowrap;
      .member {
        width: 20%;
        margin-bottom: 8px;
        text-align: center;
      }
      .avatar {
        width: 40px;
        height: 40px;
        border-radius: 50%;
      }
    }
  }
  .tit {
    font-size: 16px;
    color: #000;
    margin-bottom: 10px;
  }
  ul {
    padding-left: 16px;
    margin-bottom: 20px;
  }
  li {
    line-height: 30px;
    font-size: 14px;
    color: #222;
  }
  .detial-content {
    padding: 16px;
    background: linear-gradient(180deg, #f3eefd 0%, #ffffff 100%);
    border-radius: 10px 10px 10px 10px;
    border: 2px solid #ffffff;
  }
  .activityInstruction {
    padding: 16px;
    background: linear-gradient(180deg, #f3eefd 0%, #ffffff 100%);
    border-radius: 10px 10px 10px 10px;
    border: 2px solid #ffffff;
  }
}
.apply-buttom {
  padding-top: 10px;
  width: 100%;
  height: 90px;
  background: #fff;
  .btn {
    margin: 0 auto;
    width: 70%;
    height: 40px;
    background: linear-gradient(180deg, #946bfe 0%, #e3b8fe 100%);
    box-shadow: 0px 3px 6px 0px rgba(190, 148, 254, 0.3248);
    border: 2px solid #ffffff;
    border-radius: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    color: #fff;
  }
}
.event-info,
.event-notice {
  margin: 1rem 0;
}
.environment-images img {
  width: 100%;
  margin-bottom: 1rem;
}
</style>
